module.exports = __webpack_public_path__ + "static/img/xishan-bg1.d2aa7f81.png";